var _path;
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 26c-.55 0-1 .45-1 1v1a2 2 0 01-2 2H4a2 2 0 01-2-2V12a2 2 0 012-2h7c.55 0 1-.45 1-1s-.45-1-1-1H4a4 4 0 00-4 4v16c0 2.206 1.791 4 4 4h10a4 4 0 004-4v-1c0-.55-.45-1-1-1zM31.413 5.415L26.584.587A1.995 1.995 0 0025.17 0H18c-2.206 0-4 1.79-4 4v16a4 4 0 004 4h10a4 4 0 004-4V6.83c0-.53-.212-1.041-.587-1.416zM26 2.828L29.17 6H26V2.828zM30 20a2 2 0 01-2 2H18a2 2 0 01-2-2V4a2 2 0 012-2h6v4a2 2 0 002 2h4v12z"
  })));
}
export default SvgCopy;